import { store$ } from '@redux/store';
import { distinctUntilChanged, fromEvent, map } from 'rxjs';
import { selectListingCount } from 'features/searchResultsFacets';
import fastdom from 'fastdom';

const backToTopButtonElement = document.querySelector('[data-back-to-top]');

const initBackToTopElement = () => {
  const clickBackToTop$ = fromEvent(backToTopButtonElement, 'click');

  /**
   * listening to changes on the store. When new results arrived to the search results page, this observable
   * will emit the amount of results shown to the user.
   */
  const onNewListings$ = store$.pipe(map(selectListingCount), distinctUntilChanged());

  /**
   * toggleBackToTopVisibility: when no results, hides the back to top button. Shows back to top when there
   * are results to display.
   * @param listingCount - an integer representing the amount of listings in the current search results page.
   */
  const toggleBackToTopVisibility = (listingCount) => {
    if (listingCount > 0) {
      backToTopButtonElement.removeAttribute('hidden');
    } else {
      backToTopButtonElement.setAttribute('hidden', '');
    }
  };

  clickBackToTop$.subscribe(() => {
    fastdom.mutate(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, window);
  });
  onNewListings$.subscribe(toggleBackToTopVisibility);
}

if (backToTopButtonElement) {
  initBackToTopElement();
}